import { IOrder, IOrderCustomer, IOrderPaymentCondition } from '@/interfaces/Order';
import { IContract } from '@/interfaces/Contract';

import { EPaymentMethod, EOrderStatus } from '@/helpers/enums';

export class Order implements IOrder {
  id: number|null = null;
  id_offer: number|null = null;
  id_seller: number|null = null;
  id_bill: number|null = null;
  customer: IOrderCustomer|null = null;
  contracts: IContract[] = new Array<IContract>();
  payment_conditions: IOrderPaymentCondition[] = new Array<IOrderPaymentCondition>();
  payment_method_code: EPaymentMethod|null;
  source: string|null = null;
  offer_name: string|null = null;
  status: EOrderStatus|null = null;
  first_cycle_start: string|null = null;
  first_cycle_end: string|null = null;
  price: number|null = null;
  cart_price: number|null = null;
  offer_price: number|null = null;
  cart_discount_amount: number|null = null;
  extra_params: string|null = null;
  bankslip_url: string|null = null;
  bankslip_barcode: string|null = null;
  renewed_date: string = '';
  transfer_metadata: any;

  constructor(order: IOrder) {
    Object.assign(this, { ...order });
  }

  isFreeOrder(): boolean {
    return this.isFreeOrderByCredit() || this.isFreeOrderByDiscount();
  }

  isFreeOrderByCredit(): boolean {
    return this.payment_conditions.some((condition: IOrderPaymentCondition) => {
      return condition.payment_method_code === EPaymentMethod.storeCredit &&
        condition.amount == this.cart_price;
    });
  }

  isFreeOrderByDiscount(): boolean {
    return this.cart_discount_amount === this.cart_price;
  }
}
